import { render, staticRenderFns } from "./WorkerChronology.vue?vue&type=template&id=283cb965&scoped=true"
import script from "./WorkerChronology.vue?vue&type=script&lang=ts"
export * from "./WorkerChronology.vue?vue&type=script&lang=ts"
import style0 from "./WorkerChronology.vue?vue&type=style&index=0&id=283cb965&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283cb965",
  null
  
)

export default component.exports